import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-novo-beneficio',
  templateUrl: './novo-beneficio.component.html'
})
export class NovoBeneficioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
